module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_16_2.b3903223.jpeg";